module.exports = __webpack_public_path__ + "img/fog.52818203.png";